module.exports = __webpack_public_path__ + "img/00025.3901e194.webp";